import {
  APIPlanDefinition,
  type APIPlanDefinitionResponseType,
  type IAPIPlanDefinition,
} from "@/core/data_sources/models/APIPlanDefinition";
import { State } from "@/core/data_sources/store/state";

export type PlanDefinitionsStateType = {
  list: IAPIPlanDefinition[];
  selected: IAPIPlanDefinition | null;
  count: number;
};

export class PlanDefinitionsState extends State<PlanDefinitionsStateType> {
  constructor() {
    super({ list: [], selected: null, count: 0 });
  }

  setPlans(plans: APIPlanDefinitionResponseType[]) {
    this._observable.next({
      ...(this._observable.value ?? { list: [], selected: null, count: 0 }),
      list: plans.map((plan) => new APIPlanDefinition(plan)),
    });
  }

  setPlan(plan: APIPlanDefinitionResponseType | null) {
    this._observable.next({
      ...(this._observable.value ?? { list: [], selected: null, count: 0 }),
      selected: plan ? new APIPlanDefinition(plan) : null,
    });
  }

  setCount(count: number) {
    this._observable.next({
      ...(this._observable.value ?? { list: [], selected: null, count: 0 }),
      count,
    });
  }

  clear(): void {
    this._observable.next({ list: [], selected: null, count: 0 });
  }
}
